// Optimization to avoid bloating bootstrap code with unused code
export const DEFAULT_LANGUAGE_CODE = 'en-GB';
